/**
 * HOW LONG A LAZY CHUNK MAY TAKE (rc.13, the Web Director): the booking
 * flow's step chunks and the Spanish catalogue. A request that has not
 * settled by then is treated as a failed load (shared/lib/moduleLoadFailure.ts
 * `withChunkTimeout`), which asks build-info for the honest message, so a
 * hung request never leaves a skeleton on screen indefinitely.
 *
 * Fifteen seconds: far above any chunk's real load (2 to 6 KiB; about 0.7 s
 * on Slow 4G, rc.12's QE), and short enough that a person is not left
 * staring at a shimmer.
 */
export const CHUNK_WAIT_MS = 15_000;
